import React from "react"
import { INode } from "svgson"

const stripList = ["xmlns:", "rdf:", "inkscape:", "-inkscape-font-specification", "sodipodi"]

const htmlDecode = (input: string) => {
    const e = document.createElement("div")
    e.innerHTML = input
    const val = e.childNodes[0].nodeValue as string
    if (val) {
        return val
    }
    return ""
}

const styleToObject = (input: string) => {
    const result: any = {}
    const attributes = input.split(";")

    for (let i = 0; i < attributes.length; i++) {
        const entry = attributes[i].split(":")
        const keyR = entry.splice(0, 1)[0]
        const key = covertToCamelCase(keyR.trim(), "-")
        if (key === "") continue
        const value = entry.join(":")
        result[key] = value.trim()
    }
    return result
}

const capitalizeFirstLetter = (key: string) => {
    return key.charAt(0).toUpperCase() + key.slice(1)
}

const covertToCamelCase = (key: string, splitter: string): string => {
    if (!key.includes(splitter)) return key
    const [head, tail] = key.split(splitter)
    return `${head}${covertToCamelCase(capitalizeFirstLetter(tail), splitter)}`
}

const attrConvert = (key: string, value: any) => {
    if (stripList.some(sl => key.includes(sl))) return [key, null]
    if (key === "class") return ["className", value]
    if (key === "style") {
        const s = styleToObject(value)
        return ["style", s]
    }
    if (key.includes("-")) {
        if (key.startsWith("data-")) return [key, value]
        return [covertToCamelCase(key, "-"), value]
    }
    if (key.includes(":")) {
        return [covertToCamelCase(key, ":"), value]
    }

    return [key, value]
}

const parseAttrs = (attrs: any) => {
    if (!attrs) return {}
    let newAttrs: any = {}

    Object.entries(attrs).forEach(([key, value]) => {
        const [newKey, newValue] = attrConvert(key, value)
        if (newValue) {
            newAttrs[newKey] = newValue
        }
    })
    return newAttrs
}

export function SVGFromJson<T>({ json, data, ...rest }: { json: INode; data?: T }) {
    if (!json) return null
    if (json.type === "text") {
        return <React.Fragment>{htmlDecode(json.value)}</React.Fragment>
    }
    const attrs = parseAttrs(json.attributes)

    let mainSVG: React.ReactNode[] = []

    if (json.children && Array.isArray(json.children)) {
        mainSVG = json.children.map((c: any, idx: number) => {
            return <SVGFromJson json={c} data={data} key={idx} />
        })
    }

    return React.createElement(json.name, attrs, mainSVG)
}
